import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import {
    isRecordingBanAllowedSelector,
    isRecordingForMembersAllowedSelector,
    setRecordingForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { Switch } from '../../../../../components';
import { i18n } from '../../../../../helpers/i18n';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import styles from './styles.css';

export const LocalRecordingSwitcher: FunctionComponent = () => {
    const hasBanPermission = useSelector(isRecordingBanAllowedSelector);
    const hasMembersPermission = useSelector(isRecordingForMembersAllowedSelector);

    const onChange = useOnPermissionChange(setRecordingForMembersAllowed, 'recording');

    if (!hasBanPermission) {
        return null;
    }

    return (
        <Switch
            className={styles.switch}
            labelAfter={i18n('settings', 'permission-ban-recording')}
            checked={hasMembersPermission}
            onChange={onChange}
            size="sm"
            stretch
            shrink
        />
    );
};
